// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#2497ed","colorSecondary":"#eaf5fe","root":"CalculationProgress_root__2rj6_"};